import { Color } from '@persona-id/design-tokens';

/**
 * There is intentionally no trailing semi. This makes it easier to compose shadows.
 * BOX_SHADOWS => Elevation
 * base => Low
 * card => Mid
 * popover => High
 */
export enum Elevation {
  High = '0px 11px 15px rgba(191, 191, 199, 0.2), 0px 9px 46px rgba(191, 191, 199, 0.12), 0px 24px 38px rgba(191, 191, 199, 0.14)',
  Mid = '0px 10px 14px rgba(0, 0, 0, 0.08), 0px 6px 6px rgba(0, 0, 0, 0.06)',
  Low = '0px 4px 5px rgba(191, 191, 199, 0.2), 0px 3px 14px rgba(191, 191, 199, 0.12), 0px 8px 10px rgba(191, 191, 199, 0.14)',
}

// String enums cannot have computed members, so we use an object.
export const Hairline = {
  Bottom: `0px 1px 0px ${Color.BorderHairline}`,
  Top: `0px -1px 0px ${Color.BorderHairline}`,
  Right: `1px 0px 0px ${Color.BorderHairline}`,
};
